export default "__VITE_ASSET__qjZaBKdJ__"